/**
 * Hold reasons that only the system writes (Phase 104, BLU-1450, D-13 / D-26).
 * A manual order waiting on customer art approval, or on an artwork file / its
 * built print file. Never an operator choice: the hold INPUT enum stays the
 * three operator reasons, so nobody can pick these by hand. They release only
 * through Mark approved or the last file landing; no generic release path may
 * clear them (D-28). The prod_orders.hold_reason CHECK (20261019130000) keeps
 * both values. The one list: backend and frontend import it from here.
 */
export const ART_HOLD_REASONS = ['art_approval', 'awaiting_artwork'];
export function isArtHoldReason(reason) {
    return reason === 'art_approval' || reason === 'awaiting_artwork';
}
